import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-widget',
  template: `
    <div
      visibility="hidden"
      class="mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-5 text-center dark:bg-white/[0.03]"
    >
      <!--
      <h3 class="mb-2 font-semibold text-gray-900 dark:text-white">
        Fin
      </h3>
      -->
    </div>
  `
})
export class SidebarWidgetComponent { } 